import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, switchMap, take } from 'rxjs';
import { environment } from '../../environments/environment';
import { KioskoService } from '../services/local/kiosko.service';
import { PrinterConfigService } from '../services/local/printer-config.service';

export const kioskoStartGuard: CanActivateFn = () => {
  const kioskoService = inject(KioskoService);
  const printerConfigService = inject(PrinterConfigService);
  const router = inject(Router);

  return toObservable(kioskoService.kioskoInfo.isLoading).pipe(
    filter(isLoading => !isLoading),
    take(1),
    switchMap(async () => {
      // En Capacitor, sin impresora configurada no tiene caso mandar al operador a ningún flujo
      // de turnos — no podría imprimir el ticket. Se le lleva directo a configurarla.
      if (environment.capacitor && !(await printerConfigService.hasConfig())) {
        return router.parseUrl('/v2/configuracion-impresora');
      }

      const startRoute = kioskoService.startRoute();
      return startRoute === '/v2/inicio' ? true : router.parseUrl(startRoute);
    })
  );
};
